<pdq-card variant="popover" color="white" class="badge-editor" [formGroup]="badgeForm">
  <div class="badge-editor__header" [class.badge-editor__header--editing]="editingName">
    @if (editingName && currentType === BadgeType.CUSTOM_MESSAGE) {
      <pdq-input
        class="badge-editor__name-input"
        formControlName="name"
        placeholder="Custom message"
        [autofocus]="true"
        (focusout)="stopEditingName()"
        (onEnter)="stopEditingName()"></pdq-input>
    } @else {
      <div class="badge-editor__title">
        <pdq-drag-and-drop class="badge-editor__handle" size="medium" spacing="tight"></pdq-drag-and-drop>
        @if (currentType === BadgeType.CUSTOM_MESSAGE) {
          <pdq-heading element="h7">{{ customMessageDisplayName }}</pdq-heading>
          <pdq-icon
            icon="oeag"
            size="small"
            color="var(--primary-default)"
            class="badge-editor__icon-btn"
            (click)="startEditingName(); $event.stopPropagation()"></pdq-icon>
        } @else {
          <pdq-heading element="h7">{{ badgeTypeLabel(currentType) }}</pdq-heading>
        }
      </div>
      <div class="badge-editor__actions">
        <pdq-icon
          icon="duplicate"
          size="small"
          color="var(--on-surface-light)"
          class="badge-editor__icon-btn"
          matTooltip="Duplicate"
          matTooltipClass="pdq-mat-tooltip"
          (click)="duplicateRequested.emit(); $event.stopPropagation()"></pdq-icon>
        <pdq-icon
          icon="trash"
          size="small"
          color="var(--error-default)"
          class="badge-editor__icon-btn"
          (click)="removeRequested.emit(); $event.stopPropagation()"></pdq-icon>
        <pdq-icon
          [icon]="expanded ? 'collapsing-arrow-up' : 'collaping-arrow-down'"
          size="small"
          color="var(--on-surface-light)"
          class="badge-editor__icon-btn"
          (click)="toggleExpanded(); $event.stopPropagation()"></pdq-icon>
      </div>
    }
  </div>

  @if (expanded) {
    <div class="card-content">
      @if (currentType === BadgeType.LOW_STOCK) {
        <div class="stacked-row">
          <span class="section-label">Show boost when stock is</span>
          <div class="inline-row">
            <span class="inline-label">Between</span>
            <pdq-input-arrows formControlName="minStock" [min]="0" widthSize="xlarge"></pdq-input-arrows>
            <span class="inline-label">and</span>
            <pdq-input-arrows formControlName="maxStock" [min]="0" widthSize="xlarge"></pdq-input-arrows>
            <span class="inline-label">stock items</span>
          </div>
          <span class="hint">If a product is out of stock, the boost won't display.</span>
          @if (badgeForm.errors?.['minMaxRange'] && badgeForm.touched) {
            <span class="error-message">Minimum stock cannot be greater than maximum.</span>
          }
        </div>
      }

      @if (currentType === BadgeType.RECENT_PURCHASES) {
        <div class="stacked-row">
          <span class="section-label">Minimum Purchases</span>
          <div class="inline-row inline-row--equal">
            <pdq-input-arrows formControlName="minPurchases" [min]="0" widthSize="fullwidth"></pdq-input-arrows>
            <span class="inline-row__connector">in</span>
            <pdq-input-arrows formControlName="windowValue" [min]="1" widthSize="fullwidth"></pdq-input-arrows>
            <pdq-dropdown
              [options]="windowUnitDropdownOptions"
              formControlName="windowUnit"
              [fullWidth]="true"></pdq-dropdown>
          </div>
          <span class="hint">Boost won't show if fewer than this in the time window</span>
          @if (badgeForm.errors?.['recentPurchasesMaxWindow'] && badgeForm.get('windowValue')?.touched) {
            <span class="error-message">
              Maximum window is {{ badgeForm.get('windowUnit')?.value === 'days' ? '7 days' : '168 hours' }}
            </span>
          }
        </div>
      }

      <div class="stacked-row">
        <span class="section-label">Text</span>
        <rich-text-editor
          [control]="badgeForm.controls.richTextTemplate"
          [placeholder]="currentPlaceholder"
          [disabledFormats]="hiddenRichTextFormats"
          [config]="richTextConfig"></rich-text-editor>
        @if (currentType === BadgeType.LOW_STOCK) {
          <span class="hint">Dynamic field available - {{ '{count}' }} for remaining stock</span>
        }
        @if (currentType === BadgeType.RECENT_PURCHASES) {
          <span class="hint"
            >Dynamic fields available - {{ '{count}' }}, {{ '{hours}' }} - Total of {{ '{count}' }} items bought in the
            last {{ '{hours}' }} hours.</span
          >
        }
        @if (
          badgeForm.controls.richTextTemplate.errors?.['invalidPlaceholders'] &&
          badgeForm.controls.richTextTemplate.touched
        ) {
          <span class="error-message"
            >Unsupported placeholders for this boost type:
            {{ badgeForm.controls.richTextTemplate.errors?.['invalidPlaceholders'].join(', ') }}</span
          >
        }
      </div>

      <div class="badge-style-row">
        <pdq-input-color
          label="Background Color"
          [control]="backgroundColorControl"
          [formControl]="backgroundColorControl"
          [clearable]="true"
          clearTooltip="Clear background"
          (cleared)="clearBackgroundColor()"></pdq-input-color>
        <pdq-input-color
          label="Text Color"
          [control]="textColorControl"
          [formControl]="textColorControl"></pdq-input-color>
        <pdq-dropdown
          formControlName="cornerRadius"
          title="Corner Radius"
          [options]="cornerRadiusOptions"></pdq-dropdown>
      </div>

      <div class="icon-picker">
        <label class="section-label">Icon</label>
        <pdq-iconpicker
          [presetIconUrls]="presetIconKeys"
          [presetIconLabels]="presetIconLabels"
          [presetsAsIcons]="true"
          [iconUrl]="iconValue"
          [customIconUrl]="customIconSrc"
          (iconUrlChange)="onIconUrlChange($event)"
          (uploadCustomRequested)="onUploadCustomIcon()"
          (removeCustomRequested)="onRemoveCustomIcon()">
        </pdq-iconpicker>
      </div>
    </div>
  }
</pdq-card>
